export default {
  pages: {
    installmentPayment: {
      title: 'Оплата рассрочек клиентов',
    },
  },
};
